export default "__VITE_ASSET__BF4lmp5G__"